import { ActiveView, GetActiveViewInput } from "@/graphql/generated/graphql";
import { FieldFunctionOptions, FieldPolicy, Reference, TypePolicies } from "@apollo/client";

export const viewTypePolicies: TypePolicies = {
  ActiveView: {
    keyFields: ["key", "workspaceId"],
  },
};

export const activeViewQueryFieldPolicy: FieldPolicy<
  ActiveView | undefined,
  ActiveView | undefined,
  Reference | undefined,
  FieldFunctionOptions<{ getActiveViewInput?: GetActiveViewInput }>
> = {
  read(activeView, { args, toReference }): Reference | undefined {
    if (activeView) {
      activeView;
    }
    return toReference({
      __typename: "ActiveView",
      key: args?.getActiveViewInput?.key ?? "",
      workspaceId: args?.getActiveViewInput?.workspaceId ?? "",
    });
  },
};

export const activeViewListFieldPolicy: FieldPolicy<ActiveView[], ActiveView[], ActiveView[], FieldFunctionOptions> = {
  merge(_existing: readonly ActiveView[] | undefined, incoming: readonly ActiveView[]) {
    return incoming;
  },
};
